import { useState } from "react";
import FileUploadUI from "./components/file_upload_ui";
import FileListUI from "./components/file_list_ui";

export default function FileUpload(props) {
  const [viewMode, setViewMode] = useState("file");
  const toggleViewMode = (mode) => {
    setViewMode(mode);
  };
  return (
    <div>
      <h3>Core Lab</h3>

      {viewMode === "folder" && (
        <FileUploadUI from_module_bar toggleViewMode={toggleViewMode} viewMode={viewMode} parent={"corelab"} />
      )}
      {viewMode === "file" && <FileListUI from_module_bar toggleViewMode={toggleViewMode} viewMode={viewMode} />}
    </div>
  );
}
